/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Faceta API
 * API мультитенантного admin-движка Faceta. Спека генерируется из типов Go и является контрактом для фронтенда.
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ActivityPlatformParams,
  ActivitySiteParams,
  ErrorModel,
  HomeOutputBody,
  PageOutputBody
} from '../model';

import { facetaFetch } from '../../http';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type activityPlatformResponse200 = {
  data: PageOutputBody
  status: 200
}

export type activityPlatformResponse401 = {
  data: ErrorModel
  status: 401
}

export type activityPlatformResponse403 = {
  data: ErrorModel
  status: 403
}

export type activityPlatformResponse404 = {
  data: ErrorModel
  status: 404
}

export type activityPlatformResponse422 = {
  data: ErrorModel
  status: 422
}

export type activityPlatformResponse500 = {
  data: ErrorModel
  status: 500
}

export type activityPlatformResponseSuccess = (activityPlatformResponse200) & {
  headers: Headers;
};
export type activityPlatformResponseError = (activityPlatformResponse401 | activityPlatformResponse403 | activityPlatformResponse404 | activityPlatformResponse422 | activityPlatformResponse500) & {
  headers: Headers;
};

export type activityPlatformResponse = (activityPlatformResponseSuccess | activityPlatformResponseError)

export const getActivityPlatformUrl = (params?: ActivityPlatformParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/activity?${stringifiedParams}` : `/activity`
}

/**
 * Все события всех тенантов, включая вход от чужого имени. Только владельцу платформы.
 * @summary Журнал платформы
 */
export const activityPlatform = async (params?: ActivityPlatformParams, options?: Parameters<typeof facetaFetch>[1]): Promise<activityPlatformResponse> => {

  return facetaFetch<activityPlatformResponse>(getActivityPlatformUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getActivityPlatformQueryKey = (params?: ActivityPlatformParams,) => {
    return [
    `/activity`, ...(params ? [params] : [])
    ] as const;
    }


export const getActivityPlatformQueryOptions = <TData = Awaited<ReturnType<typeof activityPlatform>>, TError = ErrorModel>(params?: ActivityPlatformParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityPlatform>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivityPlatformQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activityPlatform>>> = ({ signal }) => activityPlatform(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activityPlatform>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivityPlatformQueryResult = NonNullable<Awaited<ReturnType<typeof activityPlatform>>>
export type ActivityPlatformQueryError = ErrorModel


export function useActivityPlatform<TData = Awaited<ReturnType<typeof activityPlatform>>, TError = ErrorModel>(
 params: undefined |  ActivityPlatformParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityPlatform>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityPlatform>>,
          TError,
          Awaited<ReturnType<typeof activityPlatform>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivityPlatform<TData = Awaited<ReturnType<typeof activityPlatform>>, TError = ErrorModel>(
 params?: ActivityPlatformParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityPlatform>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityPlatform>>,
          TError,
          Awaited<ReturnType<typeof activityPlatform>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivityPlatform<TData = Awaited<ReturnType<typeof activityPlatform>>, TError = ErrorModel>(
 params?: ActivityPlatformParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityPlatform>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Журнал платформы
 */

export function useActivityPlatform<TData = Awaited<ReturnType<typeof activityPlatform>>, TError = ErrorModel>(
 params?: ActivityPlatformParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activityPlatform>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivityPlatformQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type siteHomeResponse200 = {
  data: HomeOutputBody
  status: 200
}

export type siteHomeResponse401 = {
  data: ErrorModel
  status: 401
}

export type siteHomeResponse403 = {
  data: ErrorModel
  status: 403
}

export type siteHomeResponse404 = {
  data: ErrorModel
  status: 404
}

export type siteHomeResponse422 = {
  data: ErrorModel
  status: 422
}

export type siteHomeResponse500 = {
  data: ErrorModel
  status: 500
}

export type siteHomeResponseSuccess = (siteHomeResponse200) & {
  headers: Headers;
};
export type siteHomeResponseError = (siteHomeResponse401 | siteHomeResponse403 | siteHomeResponse404 | siteHomeResponse422 | siteHomeResponse500) & {
  headers: Headers;
};

export type siteHomeResponse = (siteHomeResponseSuccess | siteHomeResponseError)

export const getSiteHomeUrl = (id: string,
    kind: 'production' | 'development',) => {




  return `/sites/${id}/environments/${kind}/home`
}

/**
 * Что ждёт человека, что он недавно правил, что делала команда, цифры недели и расхождения Development с Production. Видно всем, кто читает содержимое окружения.
 * @summary Главная окружения
 */
export const siteHome = async (id: string,
    kind: 'production' | 'development', options?: Parameters<typeof facetaFetch>[1]): Promise<siteHomeResponse> => {

  return facetaFetch<siteHomeResponse>(getSiteHomeUrl(id,kind),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSiteHomeQueryKey = (id: string,
    kind: 'production' | 'development',) => {
    return [
    `/sites/${id}/environments/${kind}/home`
    ] as const;
    }


export const getSiteHomeQueryOptions = <TData = Awaited<ReturnType<typeof siteHome>>, TError = ErrorModel>(id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteHome>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSiteHomeQueryKey(id,kind);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof siteHome>>> = ({ signal }) => siteHome(id,kind, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && kind !== null && kind !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof siteHome>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SiteHomeQueryResult = NonNullable<Awaited<ReturnType<typeof siteHome>>>
export type SiteHomeQueryError = ErrorModel


export function useSiteHome<TData = Awaited<ReturnType<typeof siteHome>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteHome>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof siteHome>>,
          TError,
          Awaited<ReturnType<typeof siteHome>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSiteHome<TData = Awaited<ReturnType<typeof siteHome>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteHome>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof siteHome>>,
          TError,
          Awaited<ReturnType<typeof siteHome>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSiteHome<TData = Awaited<ReturnType<typeof siteHome>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteHome>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Главная окружения
 */

export function useSiteHome<TData = Awaited<ReturnType<typeof siteHome>>, TError = ErrorModel>(
 id: string,
    kind: 'production' | 'development', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof siteHome>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSiteHomeQueryOptions(id,kind,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type activitySiteResponse200 = {
  data: PageOutputBody
  status: 200
}

export type activitySiteResponse401 = {
  data: ErrorModel
  status: 401
}

export type activitySiteResponse403 = {
  data: ErrorModel
  status: 403
}

export type activitySiteResponse404 = {
  data: ErrorModel
  status: 404
}

export type activitySiteResponse422 = {
  data: ErrorModel
  status: 422
}

export type activitySiteResponse500 = {
  data: ErrorModel
  status: 500
}

export type activitySiteResponseSuccess = (activitySiteResponse200) & {
  headers: Headers;
};
export type activitySiteResponseError = (activitySiteResponse401 | activitySiteResponse403 | activitySiteResponse404 | activitySiteResponse422 | activitySiteResponse500) & {
  headers: Headers;
};

export type activitySiteResponse = (activitySiteResponseSuccess | activitySiteResponseError)

export const getActivitySiteUrl = (siteId: string,
    params?: ActivitySiteParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/sites/${siteId}/activity?${stringifiedParams}` : `/sites/${siteId}/activity`
}

/**
 * Кто, что и когда менял на сайте — от новых событий к старым. Доступно тем, кто управляет людьми сайта.
 * @summary Журнал сайта
 */
export const activitySite = async (siteId: string,
    params?: ActivitySiteParams, options?: Parameters<typeof facetaFetch>[1]): Promise<activitySiteResponse> => {

  return facetaFetch<activitySiteResponse>(getActivitySiteUrl(siteId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getActivitySiteQueryKey = (siteId: string,
    params?: ActivitySiteParams,) => {
    return [
    `/sites/${siteId}/activity`, ...(params ? [params] : [])
    ] as const;
    }


export const getActivitySiteQueryOptions = <TData = Awaited<ReturnType<typeof activitySite>>, TError = ErrorModel>(siteId: string,
    params?: ActivitySiteParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitySite>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivitySiteQueryKey(siteId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof activitySite>>> = ({ signal }) => activitySite(siteId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: siteId !== null && siteId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activitySite>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ActivitySiteQueryResult = NonNullable<Awaited<ReturnType<typeof activitySite>>>
export type ActivitySiteQueryError = ErrorModel


export function useActivitySite<TData = Awaited<ReturnType<typeof activitySite>>, TError = ErrorModel>(
 siteId: string,
    params: undefined |  ActivitySiteParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitySite>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activitySite>>,
          TError,
          Awaited<ReturnType<typeof activitySite>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivitySite<TData = Awaited<ReturnType<typeof activitySite>>, TError = ErrorModel>(
 siteId: string,
    params?: ActivitySiteParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitySite>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activitySite>>,
          TError,
          Awaited<ReturnType<typeof activitySite>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useActivitySite<TData = Awaited<ReturnType<typeof activitySite>>, TError = ErrorModel>(
 siteId: string,
    params?: ActivitySiteParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitySite>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Журнал сайта
 */

export function useActivitySite<TData = Awaited<ReturnType<typeof activitySite>>, TError = ErrorModel>(
 siteId: string,
    params?: ActivitySiteParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof activitySite>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getActivitySiteQueryOptions(siteId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






